import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";
import { auth } from "./modules/auth";
import { stageConfig } from "./modules/stageConfig";
// @ts-ignore
import tokenExchange from "./modules/tokenExchange";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0"
  },
  modules: {
    auth,
    stageConfig,
    tokenExchange
  }
};

export default new Vuex.Store<RootState>(store);
